<template>
  <div class="cooperative-school">
    <el-form size="mini" :inline="true">
      <el-form-item label="学校名称">
        <el-input placeholder="请输入学校名称" v-model="ruleForm.educational_institution_name"></el-input>
      </el-form-item>
      <el-form-item label="平台账号">
        <el-input placeholder="请输入平台账号" v-model="ruleForm.username"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary">查询</el-button>
      </el-form-item>

      <el-button size="mini" style="float: right" @click="addSchool" type="primary" icon="el-icon-plus">新增体验校区</el-button>
    </el-form>
    <div class="table-style">
      <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column width="50" align="center" prop="id" label="序号" fixed="left">
          <template slot-scope="scope">{{
            scope.$index + 1 + 20 * (page_no - 1)
          }}</template>
        </el-table-column>

        <el-table-column width="200" align="left" label="校区名称" fixed="left">
          <template slot-scope="scope">
            <el-link @click="updateInfo(scope.row)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="二级域名">
          <template slot-scope="scope">
            <el-link @click="GogoSchool(scope.row.domain)" type="info">
              {{ scope.row.domain }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" label="地区">
          <template slot-scope="scope">
            <span>{{ scope.row.province }}-</span>
            <span>{{ scope.row.city }}-</span>
            <span>{{ scope.row.area }}</span>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" label="超管信息">
          <template slot-scope="scope">
            <span v-for="item of scope.row.principalList" :key="item.id">
              <span>{{ item.realname }}</span>
              <span>{{ '(' + item.name + ')' }}</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="已用空间">
          <template slot-scope="scope">
            <span v-if="
                scope.row.use_storage >= 1024 && scope.row.use_storage < 1048576
              ">
              {{ parseFloat(scope.row.use_storage / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.use_storage < 1024">{{ scope.row.use_storage }} KB</span>
            <span v-else>
              {{ parseFloat(scope.row.use_storage / 1024 / 1024).toFixed(2) }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="总空间">
          <template slot-scope="scope">
            <span v-if="
                scope.row.total_storage >= 1024 &&
                  scope.row.total_storage < 1048576
              ">
              {{ parseFloat(scope.row.total_storage / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.total_storage < 1024">{{ scope.row.total_storage }} KB</span>
            <span v-else>
              {{ parseFloat(scope.row.total_storage / 1024 / 1024).toFixed(2) }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="剩余流量">
          <template slot-scope="scope">
            <span v-if="
                scope.row.remain_traffic >= 1024 &&
                  scope.row.remain_traffic < 1048576
              ">
              {{ parseFloat(scope.row.remain_traffic / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.remain_traffic < 1024">{{ scope.row.remain_traffic }} KB</span>
            <span v-else>
              {{
                parseFloat(scope.row.remain_traffic / 1024 / 1024).toFixed(2)
              }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column width="180" align="left" prop="stu_remain_time" label="剩余学员时长(天)"></el-table-column>

        <el-table-column width="150" align="left" label="客户标签">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="item in scope.row.schoolTagArr" :key="item.id" :color="item.tagInfo.color">
              <span style="color: white">{{ item.tagInfo.name }}</span>
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column width="80" align="center" label="题库权限">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" effect="dark" v-if="scope.row.question_bank_permission"></el-tag>
            <el-tag size="mini" v-else type="info" effect="dark"></el-tag>
          </template>
        </el-table-column>

        <el-table-column width="180" align="left" prop="remarks" label="备注"></el-table-column>

        <el-table-column width="150" align="left" prop="off_time" label="到期时间"></el-table-column>

        <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                权限管理
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="AddSubject(scope.row)">科目授权</el-dropdown-item>

                <el-dropdown-item @click.native="AddCourse(scope.row)">课程授权</el-dropdown-item>

                <el-dropdown-item @click.native="AddData(scope.row)">校区资源</el-dropdown-item>

                <el-dropdown-item @click.native="AddAccount(scope.row)">校长管理</el-dropdown-item>

                <el-dropdown-item @click.native="AddFiles(scope.row)">下载中心</el-dropdown-item>

                <el-dropdown-item @click.native="LookOrder(scope.row)">查询订单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="20" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>
    <el-dialog :title="schoolId ? '修改学校信息' : '新增合作学校'" :visible.sync="dialogVisible" width="60%">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="学校名称" required prop="educational_institution_name">
          <el-input placeholder="请输入学校名称" v-model="form.educational_institution_name" style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="二级域名" required prop="domain">
          <el-input placeholder="请输入二级域名" v-model="form.domain" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="截止日期" required prop="off_time">
          <el-date-picker v-model="form.off_time" type="date" placeholder="请选择系统截止日期" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
        </el-form-item>

        <el-form-item label="最大分校数" required prop="max_campus_num">
          <el-input-number v-model="form.max_campus_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大教师数" required prop="max_teacher_num">
          <el-input-number v-model="form.max_teacher_num" :precision="0"></el-input-number>
        </el-form-item>

        <!--
        <el-form-item label="最大学生数" required prop="max_student_num">
          <el-input-number
            v-model="form.max_student_num"
            :precision="0"
          ></el-input-number>
        </el-form-item>
        -->
        <el-form-item label="地区信息">
          <myDistrict :province.sync="form.province" :city.sync="form.city" :area.sync="form.area"></myDistrict>
        </el-form-item>

        <el-form-item label="客户标签">
          <el-select v-model="form.tagIds" multiple placeholder="请选择">
            <el-option v-for="item in schoolTagList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赛考中心">
          <el-switch v-model="form.question_bank_permission"></el-switch>
        </el-form-item>

        <el-form-item label="备注">
          <el-input placeholder="请输入学校备注" v-model="form.remarks" style="width: 400px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEducationalInstitutionList,
  addEducationalInstitution,
  updateEducationalInstitution,
  getPrincipalUserList,
  adminGetSchoolTagList,
} from '@/api/admin'

import myDistrict from '../../../components/myDistrict/myDistrict.vue'

export default {
  name: 'market-trial',
  data() {
    return {
      userList: [],
      dialogVisible: false,
      ruleForm: {
        username: '',
        educational_institution_name: '',
      },
      form: {
        educational_institution_name: '',
        domain: '',
        max_campus_num: 1,
        max_teacher_num: 1,
        max_student_num: 1,
        off_time: '',
        remarks: '',
        tagIds: [],
        province: '',
        city: '',
        area: '',
        question_bank_permission: false,
      },
      schoolId: '',
      schoolTagList: [], //标签页面
      tableData: [],
      total: 0,
      page_no: 1,
      rules: {
        educational_institution_name: [
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'blur',
          },
        ],
        domain: [
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'blur',
          },
        ],
        remarks: [
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'blur',
          },
        ],
        off_time: [
          { required: true, message: '请选择系统截止日期', trigger: 'change' },
          { required: true, message: '请选择系统截止日期', trigger: 'blur' },
        ],
      },
    }
  },

  components: { myDistrict },

  mounted() {
    //this.getEducationalInstitutionList();
    //this.getPrincipalUserList();
    //this.adminGetSchoolTagList();
  },
  methods: {
    //查询校区标签
    adminGetSchoolTagList() {
      adminGetSchoolTagList().then((res) => {
        console.log('查询校区标签')
        console.log(res)
        this.schoolTagList = res.schoolTagList
      })
    },

    // 获取校长账号列表
    getPrincipalUserList() {
      getPrincipalUserList({
        page_size: 200,
      }).then((res) => {
        this.userList = res.principal_user_list
      })
    },
    // 修改信息
    updateInfo(row) {
      console.log('更新学校信息')
      console.log(row)
      this.schoolId = row.id
      this.form.educational_institution_name = row.name
      this.form.domain = row.domain
      this.form.max_teacher_num = row.max_teacher_num
      this.form.max_student_num = row.max_student_num
      this.form.off_time = row.off_time
      this.form.remarks = row.remarks
      this.form.max_campus_num = row.max_campus_num

      this.form.question_bank_permission = row.question_bank_permission

      this.form.province = row.province
      this.form.city = row.city
      this.form.area = row.area

      this.form.tagIds = []
      for (let k = 0; k < row.schoolTagArr.length; k++) {
        this.form.tagIds.push(row.schoolTagArr[k].tagInfo.id)
      }

      this.dialogVisible = true
    },

    AddFiles(row) {
      console.log('下载中心')
      this.$router.push({
        name: 'download-management',
        query: {
          id: row.id,
        },
      })
    },

    AddSubject(row) {
      console.log('科目授权')
      this.$router.push({
        name: 'school-subject-permissions',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddCourse(row) {
      console.log('课程授权')
      this.$router.push({
        name: 'school-system-permissions',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddAccount(row) {
      console.log('添加校长')
      this.$router.push({
        name: 'principal-management',
        query: {
          id: row.id,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddData(row) {
      console.log('添加流量')
      this.$router.push({
        name: 'data-management',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    quitDialog() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },
    // 添加合作学校
    addSchool() {
      this.schoolId = ''
      this.dialogVisible = true

      this.form = {
        educational_institution_name: '',
        domain: '',
        max_campus_num: 1,
        max_teacher_num: 1,
        max_student_num: 1,
        off_time: '',
        remarks: '',
        tagIds: [],
        province: '',
        city: '',
        area: '',
        question_bank_permission: false,
      }
    },
    search() {
      this.page_no = 1
      this.getEducationalInstitutionList()
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.schoolId) {
            updateEducationalInstitution({
              educational_institution_id: this.schoolId,
              educational_institution_name: this.form
                .educational_institution_name,
              domain: this.form.domain,
              max_campus_num: this.form.max_campus_num,
              max_teacher_num: this.form.max_teacher_num,
              max_student_num: this.form.max_student_num,
              off_time: this.form.off_time,
              remarks: this.form.remarks,
              tagIds: JSON.stringify(this.form.tagIds),
              province: this.form.province,
              question_bank_permission: this.form.question_bank_permission,
              city: this.form.city,
              area: this.form.area,
            }).then((res) => {
              console.log('修改学校信息')
              console.log(res)
              if (res.is_update) {
                this.$message.success('修改成功')
                this.quitDialog()
                this.getEducationalInstitutionList()
              }
            })
          } else {
            console.log('新建校区参数')
            console.log(this.form)
            addEducationalInstitution({
              name: this.form.educational_institution_name,
              domain: this.form.domain,
              authMealId: this.form.meal_id,
              maxCampusNum: this.form.max_campus_num,
              maxTeacherNum: this.form.max_teacher_num,
              // max_student_num: this.form.max_student_num,
              offTime: this.form.off_time,
              remarks: this.form.remarks,

              tagIds: this.form.tagIds,
              province: this.form.province,
              questionBankPermission: this.form.question_bank_permission,
              city: this.form.city,
              area: this.form.area,
            }).then((res) => {
              console.log('新增合作校区')
              console.log(res)
              if (res.is_create) {
                this.$message.success('添加合作学校成功')
                this.quitDialog()
                this.getEducationalInstitutionList()
              }
            })
          }
        }
      })
    },
    // 获取合作学校列表
    getEducationalInstitutionList() {
      getEducationalInstitutionList({
        educational_institution_name: this.ruleForm
          .educational_institution_name,
        username: this.ruleForm.username,
        page_no: this.page_no,
      }).then((res) => {
        console.log('校区列表')
        console.log(res)
        this.tableData = res.educational_institution_list
        this.total = res.total
      })
    },

    GogoSchool(domain) {
      console.log('二级域名跳转')
      console.log(domain)
      window.open('https://' + domain + '.steam.fun', '_blank')
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.getEducationalInstitutionList()
    },

    LookOrder(row) {
      console.log('查询校区订单')
      this.$router.push({
        name: 'look-order',
        query: {
          id: row.id,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cooperative-school {
  padding: 20px;
  margin: 15px;
  background-color: #fff;
  border-radius: 5px;

  .form-style {
    margin-left: 15px;
  }

  .btn {
    margin-top: 15px;
  }
}
</style>
